import { MrbBaseRouteStore } from "mrb/core";
import { UploadedContentService } from "common/services";

class UploadedContentRouteStore extends MrbBaseRouteStore {
    constructor(rootStore, options) {
        super(rootStore, options);
        this.service = this.rootStore.createApplicationService(UploadedContentService);
        this._filterOptions = null;
    }

    async getFiles(params) {
        const response = await this.service.find(params);
        return response.data;
    }

    async getFilterOptions() {
        if (!this._filterOptions) {
            const response = await this.service.getFilterOptions();
            this._filterOptions = response.data;
        }
        return this._filterOptions;
    }

    async getDownloadUrls(keys) {
        const response = await this.service.getDownloadUrls(keys);
        return response.data;
    }

    createDownloadUrl(key) {
        const baseUrl = this.rootStore.application.baasic.getApiUrl();
        const base = this.service.routeService.getFileDownload(key);
        return `${baseUrl}${base}`;
    }

    async getSessions(params) {
        const response = await this.service.getSessions(params);
        return response.data;
    }

    async getSessionFiles(sessionKey, params) {
        const response = await this.service.find({ ...params, session: sessionKey });
        return response.data;
    }

}

export { UploadedContentRouteStore };
